module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scroll-hor-cont"
  }, [_c('table', {
    staticClass: "form-calculadora"
  }, [_c('tr', {
    staticClass: "form-titles"
  }, _vm._l((_vm.nombresCols), function(item) {
    return _c('th', [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item)
      }
    })])
  })), _vm._v(" "), _c('tr', _vm._l((_vm.ingresosMasOtrosIngresos), function(item, index) {
    return _c('td', [_c('p', {
      class: index > 0 ? 'text-xs-center' : 'font-red'
    }, [_vm._v(_vm._s(index > 0 ? '$' : '') + _vm._s(item))])])
  })), _vm._v(" "), _c('tr', _vm._l((_vm.totalGastos), function(item, index) {
    return _c('td', [_c('p', {
      class: index > 0 ? 'text-xs-center' : 'font-red'
    }, [_vm._v(_vm._s(index > 0 ? '$' : '') + _vm._s(item))])])
  })), _vm._v(" "), _c('tr', _vm._l((_vm.flujoDeCaja), function(item, index) {
    return _c('td', [_c('p', {
      class: index > 0 ? 'text-xs-center' : 'font-red'
    }, [_vm._v(_vm._s(index > 0 ? '$' : '') + _vm._s(item))])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6a085a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/FormCalculadoraTotal.vue
// module id = 1053
// module chunks = 1